module.exports = __webpack_public_path__ + "static/media/auth.c92b2d76.jpg";